import type { NotificationService } from '@backoffice-frontend/notifications/util-api';
import { BuySignalNotificationItemComponent } from './components/buy-signal-notification-item.component';

// @NgModule({
//   imports: [
//     CommonModule,

//     MatIconModule,
//     MatTooltipModule,
//     TranslocoModule,
//     FontAwesomeModule,
//   ],
//   declarations: [BuySignalNotificationItemComponent],
// })
// export class BuySignalNotificationModule {
//   constructor(notificationService: NotificationService) {
//     notificationService.registerNotificationType({
//       componentType: BuySignalNotificationItemComponent,
//       name: 'LimitReportBuySignal',
//     });
//   }
// }

export function RegisterBuySignalNotificationType(
  notificationService: NotificationService,
): void {
  notificationService.registerNotificationType({
    componentType: BuySignalNotificationItemComponent,
    name: 'LimitReportBuySignal',
  });
}

export function RegisterLimitReportPowerSignalNotificationType(
  notificationService: NotificationService,
): void {
  notificationService.registerNotificationType({
    componentType: BuySignalNotificationItemComponent,
    name: 'LimitReportPowerSignal',
  });
}

export function RegisterLimitReportGasSignalNotificationType(
  notificationService: NotificationService,
): void {
  notificationService.registerNotificationType({
    componentType: BuySignalNotificationItemComponent,
    name: 'LimitReportGasSignal',
  });
}

export function RegisterLimitReportOtherSignalNotificationType(
  notificationService: NotificationService,
): void {
  notificationService.registerNotificationType({
    componentType: BuySignalNotificationItemComponent,
    name: 'LimitReportOtherSignal',
  });
}
